import React from 'react'
import isEmpty from "lodash/isEmpty"
import styled from 'styled-components'

import Button from '@rentspree/component-2023.components.atoms.button'
import CircularProgress from '@rentspree/component-2023.components.organisms.circular-progress'
import SpaceBetweenWrapper from "components/atoms/space-between-wrapper"


const NextButton = styled(Button)`
 @media (max-width: 520px) {
    ${(props) => props.isSingleButton && `width: 100%;`};
  }
`

const LoadingStateButton = styled.div`
    height: 48px;
    background-color: #1F15E1;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-radius: 10px;
`

const ButtonSetV2 = ({
	loading,
	secondaryButton = {},
	primaryButton = {},
}) => {
	const {
		id: primaryButtonId,
		dataTestId: primaryButtonTestId,
		text: primaryButtonText,
		variant: primaryButtonVariant,
		type: primaryButtonType,
		eventData: primaryButtonEventData
	} = primaryButton
	const {
		id: secondaryButtonId,
		dataTestId: secondaryButtonTestId,
		text: secondaryButtonText,
		variant: secondaryButtonVariant,
		onClick: onSecondaryButtonClick,
		className: secondaryButtonClassName,
		color: secondaryButtonColor,
		eventData: secondaryButtonEventData
	} = secondaryButton

	return (
		<SpaceBetweenWrapper width="100%" mt={"15"}>
			{
				!isEmpty(secondaryButton) ? (
					<Button
						id={secondaryButtonId}
						data-testid={secondaryButtonTestId}
						color={secondaryButtonColor}
						className={secondaryButtonClassName}
						variant={secondaryButtonVariant}
						onClick={onSecondaryButtonClick}
						{...secondaryButtonEventData}
					>
						{secondaryButtonText}
					</Button>
				) :
					<div></div>
			}
			{
				loading ?
					<LoadingStateButton>
						<CircularProgress style={{ color: "white" }} size="small" />
					</LoadingStateButton>
					:
					<NextButton
						id={primaryButtonId}
						data-testid={primaryButtonTestId}
						type={primaryButtonType}
						variant={primaryButtonVariant}
						isSingleButton={isEmpty(secondaryButton)}
						{...primaryButtonEventData}
					>
						{primaryButtonText}
					</NextButton>
			}
		</SpaceBetweenWrapper >

	)
}


export default ButtonSetV2
